import { styled } from '@linaria/react';
import theme from '../../../../design/theme';

// Building blocks shared by the object sheet and the multi-selection panel.

export const Sheet = styled.div`
    padding: 16px;
`;

export const Group = styled.section`
    margin-bottom: 20px;
`;

export const GroupTitle = styled.h3`
    margin: 0 0 8px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: ${theme.color.grey.light};
`;

export const Rows = styled.dl`
    display: grid;
    grid-template-columns: 140px 1fr;
    row-gap: 6px;
    margin: 0;
    font-size: 13px;

    & dt {
        color: ${theme.color.grey.light};
    }

    & dd {
        margin: 0;
        color: ${theme.color.grey.dark};
        overflow-wrap: anywhere;
    }
`;
